import { ROLES } from '@/constants/roles';

export const analytics = {
  path: '/analytic/reports',
  component: () => import('./views/reports-view.vue'),
  meta: {
    title: 'Аналитика',
    icon: 'mdi-chart-arc',
    accessList: [ROLES.operator, ROLES.department],
  },
};

export default [
  analytics,
];
